// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';
import type {
  CallError_ActualRecordingIdHasChanged,
  CallError_ChannelClosed,
  CallError_ChannelDoesntExist,
  CallError_HasNoPermissionsForActionOnCall,
  CallError_HasNoPermissionsForCall,
  CallError_HasNoPermissionsForChangeWaitingRoom,
  CallError_HasNoPermissionsToFinishCallForAll,
  CallError_ParticipantLimitReached,
  CallError_ParticipantsPerRoleExceeded,
  CallError_PermissionRequestAlreadySent,
  CallError_RecordingIsStartedAlready,
  CallError_WaitingRoomRequestDoesntExist,
  CallError_WaitingRoomRequestWasRejected,
} from './call_errors_pb';
import { file_call_call_errors } from './call_errors_pb';
import type {
  CallInfo,
  CallMember,
  CallPermissions,
  MemberWithCustomPermissions,
  PersonalizedCallPermissions,
} from './call_model_pb';
import { file_call_call_model } from './call_model_pb';

/**
 * Describes the file call/call_responses.proto.
 */
export const file_call_call_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_common_common_responses, file_call_call_model, file_call_call_errors]
  );

/**
 * @generated from message com.gem.bff.contract.JoinToCallResponse
 */
export type JoinToCallResponse = Message<'com.gem.bff.contract.JoinToCallResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.JoinToCallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.JoinToCallSuccess success = 1;
         */
        value: JoinToCallSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallError.ParticipantLimitReached participantLimitReached = 3;
         */
        value: CallError_ParticipantLimitReached;
        case: 'participantLimitReached';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.JoinToCallResponse.
 * Use `create(JoinToCallResponseSchema)` to create a new message.
 */
export const JoinToCallResponseSchema: GenMessage<JoinToCallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 0);

/**
 * @generated from message com.gem.bff.contract.JoinToCallSuccess
 */
export type JoinToCallSuccess = Message<'com.gem.bff.contract.JoinToCallSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.CallInfo call = 1;
   */
  call?: CallInfo;
};

/**
 * Describes the message com.gem.bff.contract.JoinToCallSuccess.
 * Use `create(JoinToCallSuccessSchema)` to create a new message.
 */
export const JoinToCallSuccessSchema: GenMessage<JoinToCallSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 1);

/**
 * @generated from message com.gem.bff.contract.FinishForAllResponse
 */
export type FinishForAllResponse = Message<'com.gem.bff.contract.FinishForAllResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.FinishForAllResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsToFinishCallForAll hasNoPermissionsToFinishCallForAll = 3;
         */
        value: CallError_HasNoPermissionsToFinishCallForAll;
        case: 'hasNoPermissionsToFinishCallForAll';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.FinishForAllResponse.
 * Use `create(FinishForAllResponseSchema)` to create a new message.
 */
export const FinishForAllResponseSchema: GenMessage<FinishForAllResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 2);

/**
 * @generated from message com.gem.bff.contract.KickMemberResponse
 */
export type KickMemberResponse = Message<'com.gem.bff.contract.KickMemberResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.KickMemberResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.KickMemberResponse.
 * Use `create(KickMemberResponseSchema)` to create a new message.
 */
export const KickMemberResponseSchema: GenMessage<KickMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 3);

/**
 * @generated from message com.gem.bff.contract.ForceMuteResponse
 */
export type ForceMuteResponse = Message<'com.gem.bff.contract.ForceMuteResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ForceMuteResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ForceMuteResponse.
 * Use `create(ForceMuteResponseSchema)` to create a new message.
 */
export const ForceMuteResponseSchema: GenMessage<ForceMuteResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 4);

/**
 * @generated from message com.gem.bff.contract.GetCallMembersResponse
 */
export type GetCallMembersResponse = Message<'com.gem.bff.contract.GetCallMembersResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetCallMembersResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallMembersSuccess success = 1;
         */
        value: GetCallMembersSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetCallMembersResponse.
 * Use `create(GetCallMembersResponseSchema)` to create a new message.
 */
export const GetCallMembersResponseSchema: GenMessage<GetCallMembersResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 5);

/**
 * @generated from message com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsResponse
 */
export type GetCallMembersByCameraOrScreenIdsResponse =
  Message<'com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsSuccess success = 1;
           */
          value: GetCallMembersByCameraOrScreenIdsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
           */
          value: CallError_HasNoPermissionsForCall;
          case: 'hasNoPermissionsForCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsResponse.
 * Use `create(GetCallMembersByCameraOrScreenIdsResponseSchema)` to create a new message.
 */
export const GetCallMembersByCameraOrScreenIdsResponseSchema: GenMessage<GetCallMembersByCameraOrScreenIdsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 6);

/**
 * @generated from message com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsSuccess
 */
export type GetCallMembersByCameraOrScreenIdsSuccess =
  Message<'com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.CallMember members = 1;
     */
    members: CallMember[];
  };

/**
 * Describes the message com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsSuccess.
 * Use `create(GetCallMembersByCameraOrScreenIdsSuccessSchema)` to create a new message.
 */
export const GetCallMembersByCameraOrScreenIdsSuccessSchema: GenMessage<GetCallMembersByCameraOrScreenIdsSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 7);

/**
 * @generated from message com.gem.bff.contract.GetCallMembersByIdsResponse
 */
export type GetCallMembersByIdsResponse =
  Message<'com.gem.bff.contract.GetCallMembersByIdsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetCallMembersByIdsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetCallMembersByIdsSuccess success = 1;
           */
          value: GetCallMembersByIdsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
           */
          value: CallError_HasNoPermissionsForCall;
          case: 'hasNoPermissionsForCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetCallMembersByIdsResponse.
 * Use `create(GetCallMembersByIdsResponseSchema)` to create a new message.
 */
export const GetCallMembersByIdsResponseSchema: GenMessage<GetCallMembersByIdsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 8);

/**
 * @generated from message com.gem.bff.contract.GetCallMembersByIdsSuccess
 */
export type GetCallMembersByIdsSuccess =
  Message<'com.gem.bff.contract.GetCallMembersByIdsSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.CallMember members = 1;
     */
    members: CallMember[];
  };

/**
 * Describes the message com.gem.bff.contract.GetCallMembersByIdsSuccess.
 * Use `create(GetCallMembersByIdsSuccessSchema)` to create a new message.
 */
export const GetCallMembersByIdsSuccessSchema: GenMessage<GetCallMembersByIdsSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 9);

/**
 * @generated from message com.gem.bff.contract.GetCallMembersSuccess
 */
export type GetCallMembersSuccess = Message<'com.gem.bff.contract.GetCallMembersSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.CallMember members = 1;
   */
  members: CallMember[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.GetCallMembersSuccess.
 * Use `create(GetCallMembersSuccessSchema)` to create a new message.
 */
export const GetCallMembersSuccessSchema: GenMessage<GetCallMembersSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 10);

/**
 * @generated from message com.gem.bff.contract.StartCallRecordingResponse
 */
export type StartCallRecordingResponse =
  Message<'com.gem.bff.contract.StartCallRecordingResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.StartCallRecordingResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.StartCallRecordingSuccess success = 1;
           */
          value: StartCallRecordingSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
           */
          value: CallError_HasNoPermissionsForCall;
          case: 'hasNoPermissionsForCall';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ChannelClosed channelClosed = 3;
           */
          value: CallError_ChannelClosed;
          case: 'channelClosed';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.RecordingIsStartedAlready recordingIsStartedAlready = 4;
           */
          value: CallError_RecordingIsStartedAlready;
          case: 'recordingIsStartedAlready';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.StartCallRecordingResponse.
 * Use `create(StartCallRecordingResponseSchema)` to create a new message.
 */
export const StartCallRecordingResponseSchema: GenMessage<StartCallRecordingResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 11);

/**
 * @generated from message com.gem.bff.contract.StartCallRecordingSuccess
 */
export type StartCallRecordingSuccess =
  Message<'com.gem.bff.contract.StartCallRecordingSuccess'> & {
    /**
     * @generated from field: string recordingId = 1;
     */
    recordingId: string;
  };

/**
 * Describes the message com.gem.bff.contract.StartCallRecordingSuccess.
 * Use `create(StartCallRecordingSuccessSchema)` to create a new message.
 */
export const StartCallRecordingSuccessSchema: GenMessage<StartCallRecordingSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 12);

/**
 * @generated from message com.gem.bff.contract.StopCallRecordingResponse
 */
export type StopCallRecordingResponse =
  Message<'com.gem.bff.contract.StopCallRecordingResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.StopCallRecordingResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ActualRecordingIdHasChanged actualRecordingIdHasChanged = 4;
           */
          value: CallError_ActualRecordingIdHasChanged;
          case: 'actualRecordingIdHasChanged';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.StopCallRecordingResponse.
 * Use `create(StopCallRecordingResponseSchema)` to create a new message.
 */
export const StopCallRecordingResponseSchema: GenMessage<StopCallRecordingResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 13);

/**
 * @generated from message com.gem.bff.contract.GetCallPermissionsResponse
 */
export type GetCallPermissionsResponse =
  Message<'com.gem.bff.contract.GetCallPermissionsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetCallPermissionsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetCallPermissionsSuccess success = 1;
           */
          value: GetCallPermissionsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetCallPermissionsResponse.
 * Use `create(GetCallPermissionsResponseSchema)` to create a new message.
 */
export const GetCallPermissionsResponseSchema: GenMessage<GetCallPermissionsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 14);

/**
 * @generated from message com.gem.bff.contract.GetCallPermissionsSuccess
 */
export type GetCallPermissionsSuccess =
  Message<'com.gem.bff.contract.GetCallPermissionsSuccess'> & {
    /**
     * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions personalized = 1;
     */
    personalized?: PersonalizedCallPermissions;

    /**
     * @generated from field: com.gem.bff.contract.CallPermissions default = 2;
     */
    default?: CallPermissions;

    /**
     * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions defaultPersonalized = 3;
     */
    defaultPersonalized?: PersonalizedCallPermissions;

    /**
     * @generated from field: repeated com.gem.bff.contract.MemberWithCustomPermissions membersWithCustomPermissions = 4;
     */
    membersWithCustomPermissions: MemberWithCustomPermissions[];
  };

/**
 * Describes the message com.gem.bff.contract.GetCallPermissionsSuccess.
 * Use `create(GetCallPermissionsSuccessSchema)` to create a new message.
 */
export const GetCallPermissionsSuccessSchema: GenMessage<GetCallPermissionsSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 15);

/**
 * @generated from message com.gem.bff.contract.SetCallPermissionsForAllResponse
 */
export type SetCallPermissionsForAllResponse =
  Message<'com.gem.bff.contract.SetCallPermissionsForAllResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SetCallPermissionsForAllResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SetCallPermissionsForAllResponse.
 * Use `create(SetCallPermissionsForAllResponseSchema)` to create a new message.
 */
export const SetCallPermissionsForAllResponseSchema: GenMessage<SetCallPermissionsForAllResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 16);

/**
 * @generated from message com.gem.bff.contract.SetCallPermissionsForMemberResponse
 */
export type SetCallPermissionsForMemberResponse =
  Message<'com.gem.bff.contract.SetCallPermissionsForMemberResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SetCallPermissionsForMemberResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SetCallPermissionsForMemberSuccess success = 1;
           */
          value: SetCallPermissionsForMemberSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SetCallPermissionsForMemberResponse.
 * Use `create(SetCallPermissionsForMemberResponseSchema)` to create a new message.
 */
export const SetCallPermissionsForMemberResponseSchema: GenMessage<SetCallPermissionsForMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 17);

/**
 * @generated from message com.gem.bff.contract.SetCallPermissionsForMemberSuccess
 */
export type SetCallPermissionsForMemberSuccess =
  Message<'com.gem.bff.contract.SetCallPermissionsForMemberSuccess'> & {
    /**
     * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions personalized = 1;
     */
    personalized?: PersonalizedCallPermissions;
  };

/**
 * Describes the message com.gem.bff.contract.SetCallPermissionsForMemberSuccess.
 * Use `create(SetCallPermissionsForMemberSuccessSchema)` to create a new message.
 */
export const SetCallPermissionsForMemberSuccessSchema: GenMessage<SetCallPermissionsForMemberSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 18);

/**
 * @generated from message com.gem.bff.contract.ClearPermissionsForMemberResponse
 */
export type ClearPermissionsForMemberResponse =
  Message<'com.gem.bff.contract.ClearPermissionsForMemberResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.ClearPermissionsForMemberResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.ClearPermissionsForMemberResponse.
 * Use `create(ClearPermissionsForMemberResponseSchema)` to create a new message.
 */
export const ClearPermissionsForMemberResponseSchema: GenMessage<ClearPermissionsForMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 19);

/**
 * @generated from message com.gem.bff.contract.CreatePermissionRequestResponse
 */
export type CreatePermissionRequestResponse =
  Message<'com.gem.bff.contract.CreatePermissionRequestResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.CreatePermissionRequestResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.PermissionRequestAlreadySent permissionRequestAlreadySent = 4;
           */
          value: CallError_PermissionRequestAlreadySent;
          case: 'permissionRequestAlreadySent';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.CreatePermissionRequestResponse.
 * Use `create(CreatePermissionRequestResponseSchema)` to create a new message.
 */
export const CreatePermissionRequestResponseSchema: GenMessage<CreatePermissionRequestResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 20);

/**
 * @generated from message com.gem.bff.contract.GetPermissionRequestsResponse
 */
export type GetPermissionRequestsResponse =
  Message<'com.gem.bff.contract.GetPermissionRequestsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetPermissionRequestsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetPermissionRequestsSuccess success = 1;
           */
          value: GetPermissionRequestsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetPermissionRequestsResponse.
 * Use `create(GetPermissionRequestsResponseSchema)` to create a new message.
 */
export const GetPermissionRequestsResponseSchema: GenMessage<GetPermissionRequestsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 21);

/**
 * @generated from message com.gem.bff.contract.GetPermissionRequestsSuccess
 */
export type GetPermissionRequestsSuccess =
  Message<'com.gem.bff.contract.GetPermissionRequestsSuccess'> & {
    /**
     * @generated from field: repeated int64 switchOnCamera = 1;
     */
    switchOnCamera: bigint[];

    /**
     * @generated from field: repeated int64 switchOnMic = 2;
     */
    switchOnMic: bigint[];

    /**
     * @generated from field: repeated int64 shareScreen = 3;
     */
    shareScreen: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.GetPermissionRequestsSuccess.
 * Use `create(GetPermissionRequestsSuccessSchema)` to create a new message.
 */
export const GetPermissionRequestsSuccessSchema: GenMessage<GetPermissionRequestsSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 22);

/**
 * @generated from message com.gem.bff.contract.UpdatePermissionRequestForMemberResponse
 */
export type UpdatePermissionRequestForMemberResponse =
  Message<'com.gem.bff.contract.UpdatePermissionRequestForMemberResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UpdatePermissionRequestForMemberResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UpdatePermissionRequestForMemberResponse.
 * Use `create(UpdatePermissionRequestForMemberResponseSchema)` to create a new message.
 */
export const UpdatePermissionRequestForMemberResponseSchema: GenMessage<UpdatePermissionRequestForMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 23);

/**
 * @generated from message com.gem.bff.contract.UpdatePermissionRequestForAllResponse
 */
export type UpdatePermissionRequestForAllResponse =
  Message<'com.gem.bff.contract.UpdatePermissionRequestForAllResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UpdatePermissionRequestForAllResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UpdatePermissionRequestForAllResponse.
 * Use `create(UpdatePermissionRequestForAllResponseSchema)` to create a new message.
 */
export const UpdatePermissionRequestForAllResponseSchema: GenMessage<UpdatePermissionRequestForAllResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 24);

/**
 * @generated from message com.gem.bff.contract.AddMembersToCallResponse
 */
export type AddMembersToCallResponse = Message<'com.gem.bff.contract.AddMembersToCallResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.AddMembersToCallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.AddMembersToCallResponse.
 * Use `create(AddMembersToCallResponseSchema)` to create a new message.
 */
export const AddMembersToCallResponseSchema: GenMessage<AddMembersToCallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 25);

/**
 * @generated from message com.gem.bff.contract.RemoveMembersFromCallResponse
 */
export type RemoveMembersFromCallResponse =
  Message<'com.gem.bff.contract.RemoveMembersFromCallResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.RemoveMembersFromCallResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
           */
          value: CallError_HasNoPermissionsForCall;
          case: 'hasNoPermissionsForCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.RemoveMembersFromCallResponse.
 * Use `create(RemoveMembersFromCallResponseSchema)` to create a new message.
 */
export const RemoveMembersFromCallResponseSchema: GenMessage<RemoveMembersFromCallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 26);

/**
 * @generated from message com.gem.bff.contract.GetCallLinkResponse
 */
export type GetCallLinkResponse = Message<'com.gem.bff.contract.GetCallLinkResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetCallLinkResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallLinkSuccess success = 1;
         */
        value: GetCallLinkSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetCallLinkResponse.
 * Use `create(GetCallLinkResponseSchema)` to create a new message.
 */
export const GetCallLinkResponseSchema: GenMessage<GetCallLinkResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 27);

/**
 * @generated from message com.gem.bff.contract.GetCallLinkSuccess
 */
export type GetCallLinkSuccess = Message<'com.gem.bff.contract.GetCallLinkSuccess'> & {
  /**
   * @generated from field: string callLink = 1;
   */
  callLink: string;
};

/**
 * Describes the message com.gem.bff.contract.GetCallLinkSuccess.
 * Use `create(GetCallLinkSuccessSchema)` to create a new message.
 */
export const GetCallLinkSuccessSchema: GenMessage<GetCallLinkSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 28);

/**
 * @generated from message com.gem.bff.contract.UpdateWaitingRoomForMemberResponse
 */
export type UpdateWaitingRoomForMemberResponse =
  Message<'com.gem.bff.contract.UpdateWaitingRoomForMemberResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UpdateWaitingRoomForMemberResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.WaitingRoomRequestDoesntExist waitingRoomRequestDoesntExist = 2;
           */
          value: CallError_WaitingRoomRequestDoesntExist;
          case: 'waitingRoomRequestDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForChangeWaitingRoom hasNoPermissionsForChangeWaitingRoom = 3;
           */
          value: CallError_HasNoPermissionsForChangeWaitingRoom;
          case: 'hasNoPermissionsForChangeWaitingRoom';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UpdateWaitingRoomForMemberResponse.
 * Use `create(UpdateWaitingRoomForMemberResponseSchema)` to create a new message.
 */
export const UpdateWaitingRoomForMemberResponseSchema: GenMessage<UpdateWaitingRoomForMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 29);

/**
 * @generated from message com.gem.bff.contract.UpdateWaitingRoomForAllResponse
 */
export type UpdateWaitingRoomForAllResponse =
  Message<'com.gem.bff.contract.UpdateWaitingRoomForAllResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UpdateWaitingRoomForAllResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForChangeWaitingRoom hasNoPermissionsForChangeWaitingRoom = 2;
           */
          value: CallError_HasNoPermissionsForChangeWaitingRoom;
          case: 'hasNoPermissionsForChangeWaitingRoom';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UpdateWaitingRoomForAllResponse.
 * Use `create(UpdateWaitingRoomForAllResponseSchema)` to create a new message.
 */
export const UpdateWaitingRoomForAllResponseSchema: GenMessage<UpdateWaitingRoomForAllResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 30);

/**
 * @generated from message com.gem.bff.contract.WaitingRoomAccessResponse
 */
export type WaitingRoomAccessResponse =
  Message<'com.gem.bff.contract.WaitingRoomAccessResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.WaitingRoomAccessResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.WaitingRoomRequestDoesntExist waitingRoomRequestDoesntExist = 2;
           */
          value: CallError_WaitingRoomRequestDoesntExist;
          case: 'waitingRoomRequestDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.WaitingRoomRequestWasRejected waitingRoomRequestWasRejected = 3;
           */
          value: CallError_WaitingRoomRequestWasRejected;
          case: 'waitingRoomRequestWasRejected';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.WaitingRoomAccessResponse.
 * Use `create(WaitingRoomAccessResponseSchema)` to create a new message.
 */
export const WaitingRoomAccessResponseSchema: GenMessage<WaitingRoomAccessResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 31);

/**
 * @generated from message com.gem.bff.contract.DeclineCallResponse
 */
export type DeclineCallResponse = Message<'com.gem.bff.contract.DeclineCallResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.DeclineCallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.DeclineCallResponse.
 * Use `create(DeclineCallResponseSchema)` to create a new message.
 */
export const DeclineCallResponseSchema: GenMessage<DeclineCallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 32);

/**
 * @generated from message com.gem.bff.contract.CallPongResponse
 */
export type CallPongResponse = Message<'com.gem.bff.contract.CallPongResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.CallPongResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CallPongResponse.
 * Use `create(CallPongResponseSchema)` to create a new message.
 */
export const CallPongResponseSchema: GenMessage<CallPongResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 33);

/**
 * @generated from message com.gem.bff.contract.SetCallParticipantsRolesResponse
 */
export type SetCallParticipantsRolesResponse =
  Message<'com.gem.bff.contract.SetCallParticipantsRolesResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SetCallParticipantsRolesResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 2;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CallError.ParticipantsPerRoleExceeded participantsPerRoleExceeded = 3;
           */
          value: CallError_ParticipantsPerRoleExceeded;
          case: 'participantsPerRoleExceeded';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SetCallParticipantsRolesResponse.
 * Use `create(SetCallParticipantsRolesResponseSchema)` to create a new message.
 */
export const SetCallParticipantsRolesResponseSchema: GenMessage<SetCallParticipantsRolesResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 34);
